import angular from 'angular';
import _ from 'lodash';
import swal from 'sweetalert';

class FormController {
    constructor(Model) {
        this.Model = Model;
        this.fields = this.getFields();
        this.model = this.model || {};
        this.clone = angular.copy(this.model);
        console.log(this.model);
        this.onSubmit = this.onSubmit || angular.noop;
        this.onCancel = this.onCancel || angular.noop;
    }

    submit() {
        this.form.$setSubmitted(true);
        if (this.form.$invalid) {
            return;
        }
        this.Model.create(this.clone, {upsert: true}).then((data) => {
            swal("", "Podaci su uspiješno pohranjeni", "success");
            this.onSubmit({model: data});
        }).catch((error) => {
            let errorText = '';
            // debugger;
            if (error.status===500){
                errorText = 'Došlo je do pogreške na serveru. Molimo kontaktirajte administratora';
            }else{
                _.forOwn(error.data, (value, key) => {
                    errorText = errorText + `<li>${key}: ${value}</li>`;
                });
            }

            errorText = '<ul>'+ errorText + '</ul>';
            swal({
                title: "Greška",
                text: errorText,
                html: true,
                type: 'error'
            });
        });
    }

    cancel() {
        if (this.form.$pristine) {
            this.onCancel();
            return;
        }
        swal({
            title: "Jeste li sigurni?",
            text: "Podaci nisu spremljeni. Želite li zatvoriti formu za unos?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Da, zatvori!",
            cancelButtonText: 'Odustani',
            closeOnConfirm: true
        },
        () => this.onCancel());
    }

    getFields(){
        return {
            // sifra: {
            //     key: 'sifra',
            //     type: 'hInput',
            //     templateOptions: {
            //         label: 'Šifra'
            //     }
            // },
            prezime: {
                key: 'prezime',
                type: 'hInput',
                templateOptions: {
                    label: 'Prezime',
                    required: true
                }
            },
            ime: {
                key: 'ime',
                type: 'hInput',
                templateOptions: {
                    label: 'Ime',
                    required: true
                }
            },
            jmbg_oib: {
                key: 'jmbg_oib',
                type: 'hInput',
                templateOptions: {
                    label: 'OIB'
                }
            },
            datum_rodjenja: {
                key: 'datum_rodjenja',
                type: 'hDatepicker',
                templateOptions: {
                    label: 'Datum rođenja',
                    required: true
                }
            },
            ulica_kbr: {
                key: 'ulica_kbr',
                type: 'hInput',
                templateOptions: {
                    label: 'Ulica i kbr.',
                    required: true
                }
            },
            grad: {
                key: 'grad',
                type: 'hInput',
                templateOptions: {
                    label: 'Grad',
                    required: true
                }
            },
            tel_mob: {
                key: 'tel_mob',
                type: 'hInput',
                templateOptions: {
                    label: 'Telefon/Mobitel',
                    required: true
                }
            },
            zanimanje: {
                key: 'zanimanje',
                type: 'hInput',
                templateOptions: {
                    label: 'Zanimanje'
                }
            },
            email: {
                key: 'email',
                type: 'hInput',
                templateOptions: {
                    label: 'E-mail',
                }
            },
            spol: {
                key: 'spol',
                type: 'hSelect',
                templateOptions: {
                    label: 'Spol',
                    options: [
                        {value: 'M', name: 'Muški'},
                        {value: 'Ž', name: 'Ženski'},
                    ]
                }
            }
        };
    };
}

FormController.$inject = ['Pacijent'];

export default FormController;



// WEBPACK FOOTER //
// ./app/components/pacijent/form/form.controller.js